import { ErrorMessage } from '@components/error/error-message';
import { LabelPrimary } from '@components/label';

import { FieldWrapperProps } from '../dynamic-input-fields.type';

export const FieldWrapper = ({
  field,
  children,
  label,
  parentFormField,
  showLabel = true,
  showError = true,
}: FieldWrapperProps) => {
  const fieldName = parentFormField ? `${parentFormField}.${field.slug}` : field.slug;
  return (
    <>
      {showLabel && <LabelPrimary htmlFor={fieldName}>{label}</LabelPrimary>}
      {children}
      {showError && <ErrorMessage name={fieldName} className='mt-1' />}
    </>
  );
};
